
















































import { Component, Vue } from 'vue-property-decorator'

const defaultICPName = '蜀ICP备2021015471号-4'

@Component({
  name: 'Footer'
})
export default class extends Vue {
  private ICPName = defaultICPName
  private scrollTo(selector: string) {
    const $element: HTMLElement | null = document.querySelector(selector)
    $element &&
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: $element.offsetTop
      })
  }

  mounted() {
    this.ICPName = this.getICPName()
  }

  private jump(path: string, id: string) {
    if (this.$route.path !== path) {
      window.location.href = path
    } else {
      this.scrollTo(id)
    }
  }

  private getICPName() {
    const hostName = window.location.hostname
    const hostNameList = [
      { hostName: 'xiaolachuxing.com', ICPName: defaultICPName },
      { hostName: 'xlcx.cn', ICPName: '蜀ICP备2021015471号-3' },
      { hostName: 'xlcx.work', ICPName: '蜀ICP备2021015471号-2' },
      { hostName: '9xl.cn', ICPName: '蜀ICP备2021015471号-5' },
      { hostName: 'xiaolago.com', ICPName: '蜀ICP备2021015471号-1' }
    ]

    const result = hostNameList.find(item => hostName.indexOf(item.hostName) > -1)

    return result?.ICPName || defaultICPName
  }
}
